import { render, staticRenderFns } from "./spAlert.vue?vue&type=template&id=455250ee"
import script from "./spAlert.vue?vue&type=script&lang=js"
export * from "./spAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports